import type { Action } from "@/react/components/SettingsApp/Workflows/generated/WorkflowsApi.types";
import { useWorkflowToggleWithAiModal } from "@circle-react/hooks/useWorkflowToggleWithAiModal";
import type { DynamicWorkflowToggleProps } from "./DynamicWorkflowToggle";
import { DynamicWorkflowToggle } from "./DynamicWorkflowToggle";

interface WorkflowToggleWithAiModalProps
  extends Omit<DynamicWorkflowToggleProps, "isWorkflowActive" | "onChange"> {
  actions?: Action[];
  isActive: boolean;
  onToggle: () => void;
  steps?: Action["action_type"][];
  workflowId?: string;
}

/**
 * Wrapper component that encapsulates DynamicWorkflowToggle with AI modal integration.
 * Automatically handles AI activation modal logic when activating workflows with AI actions.
 */
export const WorkflowToggleWithAiModal = ({
  isActive,
  onToggle,
  actions,
  steps,
  workflowId,
  ...toggleProps
}: WorkflowToggleWithAiModalProps) => {
  const { isEffectivelyActive, handleToggleChange } =
    useWorkflowToggleWithAiModal({
      isActive,
      onToggle,
      actions,
      steps,
      workflowId,
    });

  return (
    <DynamicWorkflowToggle
      {...toggleProps}
      isWorkflowActive={isEffectivelyActive}
      onChange={handleToggleChange}
    />
  );
};
